import crud from './crud';
import clinic from './clinic';
import consulting from './consulting';
import consultingRequest from './consulting-request';
import customer from './customer';
import doctor from './doctor';
import payment from './payment';
import treatment from './treatment';
import surgery from './surgery';
import user from './user';
import notification from './notification';
import penchart from './penchart';
import prescription from './prescription';
import holiday from './holiday';
import balance from './balance';
import boilerplate from './boilerplate';
import organizations from './organizations';
import statistics from './statistics';
import settlements from './settlements';
import vital from './vital';
import injectitem from './injectitem';
import nurse from './nurse';
import chartCount from './chart-count';
import call from './call';

export default {
  crud,
  clinic,
  consulting,
  consultingRequest,
  customer,
  doctor,
  payment,
  treatment,
  surgery,
  user,
  notification,
  penchart,
  prescription,
  balance,
  boilerplate,
  organizations,
  statistics,
  holiday,
  settlements,
  vital,
  injectitem,
  nurse,
  chartCount,
  call,
};
